export const apiUrl = '/api'
